import { useEffect, useRef } from 'react';
import { useLazyQuery } from '@apollo/client/react/hooks';
import { Store } from '@oolio-group/domain';
import { GET_STORE_BY_ID } from '../../graphql/stores';
import { sessionSubject } from '../../state/sessionObservable';
import { setSession } from '../../state/preferences';
import useBehaviorSubjectState from '../rxjs/useSubjectState';

export const useStoreSync = () => {
  const { value: session } = useBehaviorSubjectState(sessionSubject);
  const hasFetchedRef = useRef(false);

  const [fetchStore] = useLazyQuery<{ store: Store }>(GET_STORE_BY_ID, {
    fetchPolicy: 'no-cache',
    onCompleted: data => {
      const store = data?.store;
      if (!store) return;
      const currentSession = sessionSubject.getValue();
      if (!currentSession?.currentStore) return;

      const updatedSession = {
        ...currentSession,
        currentStore: {
          ...currentSession.currentStore,
          merchantId: store.merchantId,
          merchantCode: store.merchantCode,
          payStoreRefs: store.payStoreRefs,
          checkoutOptions: store.checkoutOptions,
          enableLocalComms: store.enableLocalComms,
        },
      };
      sessionSubject.next(updatedSession);
      setSession(updatedSession);
    },
  });

  useEffect(() => {
    if (hasFetchedRef.current) return;
    if (session?.authorized && session?.currentStore?.id) {
      hasFetchedRef.current = true;
      fetchStore({ variables: { id: session.currentStore.id } });
    }
  }, [session?.authorized, session?.currentStore?.id, fetchStore]);
};
